import { useRef, useEffect } from "react"

const useArticleScrollTracking = (loadedArticles, currentArticleIndex, setCurrentArticleIndex) => {
  const lastScrollY = useRef(typeof window !== "undefined" ? window.scrollY : 0)
  const isScrollingDown = useRef(true)
  const articlePositions = useRef(new Map())

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = typeof window !== "undefined" && window.scrollY
      isScrollingDown.current = currentScrollY > lastScrollY.current
      lastScrollY.current = currentScrollY

      // Update article positions
      loadedArticles.forEach((article, index) => {
        const element = document.getElementById(`article-wrapper-${article.id}`)
        if (element) {
          const rect = element.getBoundingClientRect()
          articlePositions.current.set(article.id, {
            top: rect.top + window.scrollY,
            bottom: rect.bottom + window.scrollY,
            index,
          })
        }
      })

      // Find most visible article
      let maxVisibleHeight = 0
      let mostVisibleArticleIndex = currentArticleIndex

      articlePositions.current.forEach(({ top, bottom, index }) => {
        const visibleTop = Math.max(top, window.scrollY)
        const visibleBottom = Math.min(bottom, window.scrollY + window.innerHeight)
        const visibleHeight = Math.max(0, visibleBottom - visibleTop)

        if (visibleHeight > maxVisibleHeight) {
          maxVisibleHeight = visibleHeight
          mostVisibleArticleIndex = index
        }
      })

      if (mostVisibleArticleIndex !== currentArticleIndex) {
        setCurrentArticleIndex(mostVisibleArticleIndex)
      }
    }

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, { passive: true })
      return () => window.removeEventListener("scroll", handleScroll)
    }
  }, [currentArticleIndex, loadedArticles, setCurrentArticleIndex])

  return { isScrollingDown }
}

export default useArticleScrollTracking
